import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.875 2.99976C19.5766 2.99976 19.2904 3.11831 19.0793 3.32933L17.9225 4.48685L19.5135 6.07784L20.6707 4.92067C20.8817 4.70965 21.0003 4.42344 21.0003 4.125C21.0003 3.82657 20.8817 3.54036 20.6707 3.32933C20.4597 3.11831 20.1735 2.99976 19.875 2.99976ZM18.4529 7.1385L16.8625 5.54812L4.7105 17.6982C4.2703 18.1387 3.94654 18.6821 3.76884 19.279L3.36473 20.6353L4.72086 20.2312C5.31776 20.0535 5.86115 19.7299 6.30169 19.2897C6.30174 19.2896 6.30164 19.2897 6.30169 19.2897L18.4529 7.1385ZM16.309 3.98037C16.3163 3.9724 16.3238 3.96455 16.3315 3.95683L18.0185 2.26883C18.5109 1.7765 19.1788 1.49976 19.875 1.49976C20.5713 1.49976 21.239 1.77634 21.7313 2.26867C22.2237 2.761 22.5003 3.42874 22.5003 4.125C22.5003 4.82126 22.2237 5.489 21.7313 5.98133L7.36235 20.3503C6.74556 20.9668 5.98479 21.42 5.14903 21.6688L2.46418 22.4688C2.20024 22.5474 1.91443 22.4751 1.71969 22.2803C1.52495 22.0856 1.4526 21.7998 1.53125 21.5358L2.3312 18.851C2.58002 18.0152 3.03311 17.2546 3.64953 16.6378L16.309 3.98037Z"
        fill={colorValue}
      />
    </svg>
  );
};
